/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { OccEndpoint } from '@lm-nx-frontend/lm-inf-core';

export interface InquiryOccEndpoints {
  customers?: string | OccEndpoint;
  customerAddresses?: string | OccEndpoint;

  customerAddress?: string | OccEndpoint;
  customerCountries?: string | OccEndpoint;
}

declare module '@lm-nx-frontend/lm-inf-core' {
  interface OccEndpoints extends InquiryOccEndpoints {}
}
